<div class="sp-dialog__max-width-m sp-dialog__min-width-l">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onRefresh()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-dark">
      <mat-icon> refresh </mat-icon>
    </button>

    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary sp-margin__bottom">
      {{ 'STORES.LIQUIDATION_BANK_ACCOUNT_LABEL' | translate }}
    </h3>

    <div *ngIf="!is_qinetic_ps_list_running && qinetic_payment_sources?.length">
      <div class="sp-padding__x2 sp-row__center sp-background__accent sp-bank-account__height sp-border-radius__s">
        <mat-icon class="sp-margin__right-x2 sp-icon__min-width sp-color__accent-contrast"> account_balance </mat-icon>
        <h3 class="sp-color__accent-contrast sp-text__center">
          {{ qinetic_payment_sources?.[0]?.iban || '' | translate }}
        </h3>
      </div>
    </div>

    <div *ngIf="!is_qinetic_ps_list_running && !qinetic_payment_sources?.length">
      <app-shared-empty-message [empty_message]="'COMPANIES.NO_BANK_ACCOUNT_FOUND_LABEL'"></app-shared-empty-message>
    </div>

    <div
      *ngIf="is_qinetic_ps_list_running"
      class="sp-width__full sp-bank-account__height">
      <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
    </div>

    <h3 class="sp-color__primary sp-margin__top-x2 sp-margin__bottom">
      {{ 'STORES.REFUNDS_BANK_ACCOUNT_LABEL' | translate }}
    </h3>

    <div *ngIf="!is_stripe_ps_list_running && stripe_payment_sources?.length">
      <div class="sp-padding__x2 sp-row__center sp-background__accent sp-bank-account__height sp-border-radius__s">
        <mat-icon class="sp-margin__right-x2 sp-icon__min-width sp-color__accent-contrast"> account_balance </mat-icon>
        <h3 class="sp-color__accent-contrast sp-text__center">
          ****{{ stripe_payment_sources?.[0]?.stripe_sepa_debit?.last4 || '' | translate }}
        </h3>
      </div>
    </div>

    <div *ngIf="!is_stripe_ps_list_running && !stripe_payment_sources?.length">
      <app-shared-empty-message [empty_message]="'COMPANIES.NO_BANK_ACCOUNT_FOUND_LABEL'"></app-shared-empty-message>
    </div>

    <div
      *ngIf="is_stripe_ps_list_running"
      class="sp-width__full sp-bank-account__height">
      <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
    </div>
  </div>
</div>
